import PropTypes from 'prop-types'
import clsx from 'clsx'

import {
  Box,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
} from '@mui/material'
import { Trash } from 'phosphor-react'

import useTranslations from '../../../i18n/useTranslations'
import { makeFormPropTypes } from '../../../common/formikPropTypes'

import FormatNumberField from '../../../ui/components/formatNumberField'

import useStyles from './styles'

const PackageRow = ({
  onChange,
  index,
  values,
  fieldErrors,
  onDelete,
  requiredMeasures,
  onBlur,
  hasTrashIcon = true,
  packageError,
  onFocus,
}) => {
  const t = useTranslations()
  const classes = useStyles()

  const handleDelete = () => {
    onDelete(index)
  }
  
  return (
    <Box
      className={clsx(classes.row, packageError?.key && classes.rowHasError)}
    >
      <Typography variant="body2" className={classes.rowIndicator}>
        {index + 1}
      </Typography>
      <TextField
        className={classes.input}
        name={`packages[${index}].weight`}
        label={index === 0 && t('noun:weight')}
        placeholder={t('placeholder:kilograms', { number: '0' })}
        InputProps={{
          inputComponent: FormatNumberField,
          inputProps: {
            maxLength: 6,
            min: 0,
            suffix: t('placeholder:kilograms', { number: '' }),
            onChange,
            name: `packages[${index}].weight`,
          },
        }}
        value={values['weight']}
        error={fieldErrors.weight || packageError?.errorType === 'weight'}
        onFocus={onFocus}
        onBlur={onBlur}
        InputLabelProps={{ required: true }}
      />

      <TextField
        className={classes.input}
        name={`packages[${index}].length`}
        label={index === 0 && t('noun:length')}
        placeholder={t('placeholder:centimetres', { number: '0' })}
        InputProps={{
          inputComponent: FormatNumberField,
          inputProps: {
            maxLength: 6,
            min: 0,
            suffix: t('placeholder:centimetres', { number: '' }),
            onChange,
          },
        }}
        value={values['length']}
        error={
          fieldErrors.length ||
          packageError?.errorType === 'length' ||
          packageError?.errorType === 'perimeter'
        }
        onFocus={onFocus}
        onBlur={onBlur}
        InputLabelProps={{ required: requiredMeasures }}
      />

      <TextField
        className={classes.input}
        name={`packages[${index}].width`}
        label={index === 0 && t('noun:width')}
        placeholder={t('placeholder:centimetres', { number: '0' })}
        InputProps={{
          inputComponent: FormatNumberField,
          inputProps: {
            maxLength: 6,
            min: 0,
            suffix: t('placeholder:centimetres', { number: '' }),
            onChange,
          },
        }}
        value={values['width']}
        error={
          fieldErrors.width ||
          packageError?.errorType === 'width' ||
          packageError?.errorType === 'perimeter'
        }
        onFocus={onFocus}
        onBlur={onBlur}
        InputLabelProps={{ required: requiredMeasures }}
      />

      <TextField
        className={classes.input}
        name={`packages[${index}].height`}
        label={index === 0 && t('noun:height')}
        placeholder={t('placeholder:centimetres', { number: '0' })}
        InputProps={{
          inputComponent: FormatNumberField,
          inputProps: {
            maxLength: 6,
            min: 0,
            suffix: t('placeholder:centimetres', { number: '' }),
            onChange,
          },
        }}
        value={values['height']}
        error={
          fieldErrors.height ||
          packageError?.errorType === 'height' ||
          packageError?.errorType === 'perimeter'
        }
        onFocus={onFocus}
        onBlur={onBlur}
        InputLabelProps={{ required: requiredMeasures }}
      />

      <Box className={classes.actionWrapper}>
        {hasTrashIcon ? (
          <IconButton
            className={classes.actionButton}
            onClick={handleDelete}
            size="large"
          >
            <Trash />
          </IconButton>
        ) : null}
      </Box>
      {packageError?.key ? (
        <Box className={classes.rowErrors}>
          <FormHelperText error>{packageError.key}</FormHelperText>
        </Box>
      ) : null}
    </Box>
  )
}

PackageRow.propTypes = {
  ...makeFormPropTypes({
    weight: PropTypes.number,
    length: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }),

  hasTrashIcon: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  packageError: PropTypes.object,
  onFocus: PropTypes.func,
}

export default PackageRow
